import { TouchableOpacity, View, StyleSheet } from 'react-native';

import { colors, spacing } from '../../theme';
import { Text } from '../Text';
import { CloseGreenIcon } from '../../assets';

export const Chip = ({ text, onDeletePress }: Props) => {
	return (
		<View style={styles.chip}>
			<Text style={styles.chipText}>{text}</Text>
			{onDeletePress && (
				<TouchableOpacity onPress={onDeletePress}>
					<CloseGreenIcon />
				</TouchableOpacity>
			)}
		</View>
	);
};

const styles = StyleSheet.create({
	chip: {
		borderRadius: spacing(2),
		backgroundColor: colors.primary200,
		flexDirection: 'row',
		alignItems: 'center',
		alignSelf: 'flex-start',
		paddingHorizontal: spacing(),
		paddingVertical: spacing(0.5),
		margin: spacing(0.25),
		gap: spacing(),
	},
	chipText: {
		color: colors.primary700,
	},
});

type Props = {
	text: string;
	onDeletePress?: () => unknown;
};
